import React from "react";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles({
  row: {
    display: "flex",
    flexFlow: "row wrap",
    marginBottom: 8,
  },
  label: {
    marginLeft: 0,
    marginRight: "auto",
    fontSize: 14,
  },
  value: {
    fontWeight: 600,
    marginLeft: "auto",
    marginRight: 0,
    fontSize: 14,
  },
});
const TextDetailForHistory = (props) => {
  const classes = useStyles();
  return (
    <div className={classes.row}>
      <div className={classes.label}>{props.label}</div>
      <div className={classes.value}>{props.value}</div>
    </div>
  );
};

export default TextDetailForHistory;
